import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const NoteDialog = ({ mode, busy, onClose, onSubmit }) => {
  const [note, setNote] = useState('');
  const [ref, setRef] = useState('');
  useEffect(() => { setNote(''); setRef(''); }, [mode]);
  const paid = mode === 'paid';
  return (
    <Dialog open={!!mode} onOpenChange={(o) => { if (!o && !busy) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="txn-note-dialog">
        <DialogHeader>
          <DialogTitle>{paid ? 'Mark as paid' : 'Mark as failed'}</DialogTitle>
          <DialogDescription>
            {paid ? "Only do this after confirming the charge in the Plug'n Pay portal. It grants access and sends the receipt."
              : 'The customer will see this payment as failed and no access is granted.'}
          </DialogDescription>
        </DialogHeader>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3} data-testid="txn-note-input"
          placeholder={paid ? 'Required: e.g. Confirmed in portal, order 2026…' : 'Reason (optional)'} />
        {paid && <Input value={ref} onChange={(e) => setRef(e.target.value)} placeholder="Gateway reference (optional)" data-testid="txn-note-ref-input" />}
        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button onClick={() => onSubmit(note.trim(), ref.trim())} disabled={busy || (paid && note.trim().length < 5)}
            className={paid ? 'bg-emerald-600 hover:bg-emerald-700' : 'bg-red-600 hover:bg-red-700'} data-testid="txn-note-submit">
            {busy && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />}Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
